/* eslint-disable */

import { selector, selectorFamily } from 'recoil'
import { get } from '../http/restservice'
import env from '../env/env'

const UserPlansAdmin = selector({
  key: 'UserPlansAdmin',
  get: async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getPlans`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const UserBasketsAdmin = selector({
  key: 'UserBasketsAdmin',
  get: async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getUserMFBaskets`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const MFUserSubSeqBaskets = selectorFamily({
  key: 'MFUserSubSeqPlans',
  get: (clientCode) => async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/fetchSubsequentOneTimeOrder?clientCode=${clientCode}`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const MFSIPs = selectorFamily({
  key: 'MFSIPs',
  get: (clientCode) => async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/activeSIPs?clientCode=${clientCode}`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const FetchKycCustomers = selectorFamily({
  key: 'FetchKycCustomers',
  get:
    ({ page, size }) =>
      async () => {
        console.log('🚀 ~ get: ~ page, size:', page, size)
        const url = `${env.API_URL}customerservice/api/customer/fetchAllKycInitiatedCustomers?page=${page}&size=${size}`
        const response = await get(url)

        if (response.isError) {
          return []
        }
        return response
      },
})

const FetchChequeOrders = selectorFamily({
  key: 'FetchChequeOrders',
  get:
    ({ fromDateStr, toDateStr }) =>
      async () => {
        const url = `${env.API_URL}mutualfundservice/api/mutualFund/fetchChequeOrder?fromDate=${fromDateStr}&toDate=${toDateStr}`
        const response = await get(url)

        if (response.isError) {
          return []
        }
        return response
      },
})

const FetchSIPsOrders = selectorFamily({
  key: 'FetchSIPsOrders',
  get:
    ({ fromDateStr, toDateStr }) =>
      async () => {
        const url = `${env.API_URL}mutualfundservice/api/mutualFund/customerSipInfoForTracking?fromDate=${fromDateStr}&toDate=${toDateStr}`
        const response = await get(url)

        if (response.isError) {
          return []
        }
        return response
      },
})

const FetchFrontendLogs = selectorFamily({
  key: 'FetchFrontendLogs',
  get: (phoneNumber) => async () => {
    const url = `${env.API_URL}adminservice/api/actionPlan/getFrontendLogs?phoneNumber=${phoneNumber}`
    const response = await get(url)

    if (response.isError) {
      return []
    }
    return response
  },
})

const FetchOtmOrders = selectorFamily({
  key: 'FetchOtmOrders',
  get:
    ({ fromDateStr, toDateStr }) =>
      async () => {
        const url = `${env.API_URL}mutualfundservice/api/mutualFund/customerOTMOrders?fromDate=${fromDateStr}&toDate=${toDateStr}`
        const response = await get(url)

        if (response.isError) {
          return []
        }
        return response
      },
})

export {
  UserPlansAdmin,
  UserBasketsAdmin,
  MFUserSubSeqBaskets,
  MFSIPs,
  FetchKycCustomers,
  FetchChequeOrders,
  FetchFrontendLogs,
  FetchSIPsOrders,
  FetchOtmOrders,
}
